import script from "./ClipMinimap.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipMinimap.vue?vue&type=script&setup=true&lang=js"

import "./ClipMinimap.vue?vue&type=style&index=0&id=0404e34e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0404e34e"]])

export default __exports__